import React, { FC, useMemo, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import Application from 'src/front/components/Application';
import { StepperRefProps } from 'src/front/components/StepperView';

import ProblemTrackingSystemProvider from 'src/front/contexts/ProblemTrackingSystemContext';
import ClientSearch from './client-search/ClientSearch';

import Records from './records/Records';

const ProblemTrackingSystem: FC = () => {
  const { t } = useTranslation();
  const stepperRef = useRef<StepperRefProps>(null);

  const [unregisteredPerson, setUnregisteredPreson] = useState<boolean>(false);

  const goToNextStep = (): void => stepperRef.current?.goToNextStep();

  const steps = [
    {
      component: () => (
        <ClientSearch
          goToNextStep={goToNextStep}
          setUnregisteredPerson={setUnregisteredPreson}
          unregisteredPerson={unregisteredPerson}
        />
      ),
    },
    {
      component: () => <Records unregisteredPerson={unregisteredPerson} />,
    },
  ];

  const stepsVertical = useMemo(() => {
    const stepDefinitions = [
      // Client Search
      {
        text: t('problemTrackingSystem_stepper_clientSearch_text'),
      },
      // View Records / New Records
      {
        text: t('problemTrackingSystem_stepper_newRecordViewRecords_text'),
      },
    ];

    return stepDefinitions.map((item, index) => ({
      text: item.text,
      index: index + 1,
    }));
  }, [t]);

  return (
    <ProblemTrackingSystemProvider>
      <Application stepperRef={stepperRef} steps={steps} stepsVertical={stepsVertical} />
    </ProblemTrackingSystemProvider>
  );
};

export default ProblemTrackingSystem;
